var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightShapeFun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 210,
    viewBox: "0 0 190 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410097612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.8001 208.29H72.2001L190.33 12.27V4.57764e-05L64.8001 208.29Z",
    fill: "#D8DFE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M190.33 43.1701L90.4001 209.12H190.33V43.1701Z",
    fill: "#FF7236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M-7.62939e-05 209.12H51.8799L121.42 93.7301H69.5399L-7.62939e-05 209.12Z",
    fill: "#0B3742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M92.2404 69.1602H117.52L151.4 12.9402H126.12L92.2404 69.1602Z",
    fill: "#FF7236"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightShapeFun);
export default __webpack_public_path__ + "static/media/right-shape-fun.2cc128a9aaf76baf908f140175366ca9.svg";
export { ForwardRef as ReactComponent };